import { TOGGLE_FILTER_MODE } from "./filterModeActiveReducer"

export const toggleFilterMode = () => ({
    type: TOGGLE_FILTER_MODE,
})